import type { Todo } from '../../types'

interface TodoListProps {
  todos: Todo[]
  onToggle: (id: string, completed: boolean) => void
  completed?: boolean
}

const priorityColors: Record<string, string> = {
  high: 'text-seal-red',
  medium: 'text-muted-gold',
  low: 'text-mountain-green',
}

const priorityIcons: Record<string, string> = {
  high: '●',
  medium: '◐',
  low: '○',
}

export default function TodoList({ todos, onToggle, completed = false }: TodoListProps) {
  if (todos.length === 0) {
    return (
      <p className="text-mist-gray text-sm italic py-2">
        {completed ? 'No completed tasks yet.' : 'No pending tasks.'}
      </p>
    )
  }

  return (
    <ul className="space-y-2">
      {todos.map((todo) => (
        <li 
          key={todo.id} 
          className={`flex items-start gap-3 p-2 rounded-sm transition-colors ${
            completed ? '' : 'hover:bg-aged-paper/30'
          }`}
        >
          <input
            type="checkbox"
            checked={todo.completed}
            onChange={(e) => onToggle(todo.id, e.target.checked)}
            className="mt-1 w-4 h-4 text-seal-red border-muted-gold rounded focus:ring-seal-red cursor-pointer"
          />
          <div className="flex-1 min-w-0">
            <p className={`text-sm leading-relaxed ${completed ? 'line-through text-mist-gray' : 'text-ink-black'}`}>
              {todo.title}
            </p>
            {todo.description && !completed && (
              <p className="text-xs text-mist-gray mt-1">{todo.description}</p>
            )}
          </div>
          {!completed && (
            <span 
              className={`text-xs ${priorityColors[todo.priority]} flex-shrink-0`}
              title={`Priority: ${todo.priority}`}
            >
              {priorityIcons[todo.priority]}
            </span>
          )}
        </li>
      ))}
    </ul>
  )
}